import { forwardRef } from 'react';

import { ApplySelectOverlayButton } from 'components/Inputs/SelectOverlay';
import RelationshipOneInline, {
  RelationshipOneSelect,
} from 'components/Fields/InlineTableFieldInput/RelationshipOne';

import { addRelationToTeamSelector } from 'components/Fields/helpers';

import { withCellWrapper } from './../helpers';
import { getDataQAForInput } from 'components/Inputs/helpers';

const _OwnerCell = forwardRef(
  (
    {
      field,
      entityId,
      onSubmit,
      value,
      objectId: modelId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      editable,
      onAutoFocus,
      shouldFocusNext,
      enableLink = true,
      keyListenerId,
      ...others
    },
    ref
  ) => {
    const f = addRelationToTeamSelector(field);

    return (
      <RelationshipOneInline
        ref={ref}
        {...others}
        value={value}
        shouldFocusNext={shouldFocusNext}
        onSubmit={async (value) => {
          await onSubmit(value);
        }}
        readOnly={readOnly}
        onAutoFocus={onAutoFocus}
        field={f}
        entityId={entityId}
        enableLink={enableLink}
        {...getDataQAForInput(`inline-record-field-${f.name}`, f.fieldType)}
      >
        <RelationshipOneSelect
          shouldFocusNext={shouldFocusNext}
          menuLeftButton={f.isRequired ? null : menuLeftButton}
          menuRightButton={<ApplySelectOverlayButton />}
          keyListenerId={keyListenerId}
        />
      </RelationshipOneInline>
    );
  }
);

export const OwnerCell = withCellWrapper(_OwnerCell);
